import backgroundVideo from "../../assets/images/backgroundProducts.mp4";
import styled, { keyframes } from "styled-components";
import "./style.css";
const HospitalManagementSystem = () => {
  return (
    <div className="">
      <section id="heading" className="flex relative">
        {/* Background Video and Overlay */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={backgroundVideo}
          autoPlay
          loop
          muted
          style={{ opacity: "0.25" }}
        />

        {/* Main Content */}
        <div className="relative max-w-7xl mx-auto flex flex-col items-center justify-center h-screen z-10">
          <h1 className="text-5xl font-bold text-center text-white">
            <span className="gradient-headings">SmartCare HMIS by ScitForte</span>
          </h1>
          <p className="text-2xl text-white mt-6 mx-auto max-w-4xl text-center">
            SmartCare HMIS (Hospital Management Information System) is a comprehensive healthcare solution designed by ScitForte to modernize hospital operations and enhance patient care.
          </p>
        </div>
      </section>

      <section>
        
      </section>
    </div>
  );
};

export default HospitalManagementSystem;
